<div class="pagination search-set justify-content-end flex-end w-100">
    <!-- Pagination -->
    <mat-paginator
      class="demo-paginator"
      (page)="onPageChange($event)"
      [length]="totalCount"
      [pageSize]="pageSize"
      [pageSizeOptions]="[5, 10, 25, 50, 100, 500, 1000]"
      aria-label="Select page"
    ></mat-paginator>
  
    <!-- Refresh Button -->
    <img
      class="refreshIcon"
      [ngClass]="{ spin: true }"
      (click)="onRefresh()"
      src="assets/img/icons/refreshIcon.svg"
      alt="refresh"
    />
  </div>
  